// src/admin/pages/CreatePostPage.jsx

import PostEditorLayout from "../components/PostEditorLayout";
import useCategories from "../hooks/useCategories";
import usePostForm from "../hooks/usePostForm";

export default function CreatePostPage() {

    const {categories} = useCategories();

    const {
        formData,
        updateField,
        imagePreview,
        handleImageChange,
        submit,
        saving,
    } = usePostForm({
        mode: "create",
    });

    return (
        <PostEditorLayout
            title="Create Post"
            subtitle="Content Management"
            buttonLabel="Save Post"
            onSubmit={submit}
            saving={saving}
            formData={formData}
            updateField={updateField}
            imagePreview={imagePreview}
            onImageChange={handleImageChange}
            categories={categories}
        />
    );
}